import { render, staticRenderFns } from "./IpoResultFundsAccounts.vue?vue&type=template&id=0b78cc8c"
import script from "./IpoResultFundsAccounts.vue?vue&type=script&lang=js"
export * from "./IpoResultFundsAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports